import { Skeleton } from "@/core/components/ui/skeleton";
import { CarouselInsightsSkeleton } from "@/core/components/layout/carousel-insights/components/carousel-insights-skeleton";
import { DashboardPanel } from "@/dashboard/components/dashboard-ds";

export function InsightsCardsConsumptionSkeleton({
  carousel = false,
}: {
  carousel?: boolean;
}) {
  return carousel ? (
    <CarouselInsightsSkeleton />
  ) : (
    <DashboardPanel
      data-testid="insights-card-skeleton"
      footer={<Skeleton className="w-full h-9 rounded-full" />}
    >
      <div className="flex flex-col gap-2">
        <Skeleton className="w-40 h-6" />
        <Skeleton className="w-3/4 h-5" />
      </div>
      <div className="grid grid-cols-2 gap-2">
        <Skeleton className="h-24 rounded-3xl" />
        <Skeleton className="h-24 rounded-3xl" />
      </div>
    </DashboardPanel>
  );
}
